import api from "../services/api";

const path = "botaopontoacesso";

export const getButtonPointAccesss = async () => {
  return await api.get(`${path}`);
};

export const findButtonPointAccess = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editButtonPointAccess = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createButtonPointAccess = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteButtonPointAccess = async ({ id }) => {
  return await api.delete(`${path}/${id}`);
};
